import { combineReducers } from 'redux'

import minimal from './get/minimal'
import basic from './get/basic'
import full from './get/full'

export default combineReducers({
  minimal,
  basic,
  full
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/products/get.js